/* eslint-disable standard/computed-property-even-spacing */
import Trail from '@/resources/models/Trail'
import { getUserFriendlyPrivilegedTrailLabel } from '@/utilities/trail.helper'

export default class PrivilegedTrail extends Trail {
  constructor (uuid = null, attributes = {}, options = {}) {
    super(uuid, attributes, options)
    this.privilege = true
  }

  createTrailLabel (label) {
    return getUserFriendlyPrivilegedTrailLabel(label)
  }
}



// WEBPACK FOOTER //
// ./src/resources/models/PrivilegedTrail.js